import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { ErrorCarIcon } from '../../icons/ErrorCarIcon.js';
import styles from './Error.module.scss.js';

var DEFAULT_TITLE = 'Sorry, something went wrong';
var DEFAULT_DESC = 'Refresh the page or clear your cache and try again later';
var Error = function (_a) {
    var children = _a.children, _b = _a.title, title = _b === void 0 ? DEFAULT_TITLE : _b, _c = _a.description, description = _c === void 0 ? DEFAULT_DESC : _c, className = _a.className, style = _a.style;
    return (jsxs("div", __assign({ className: clsx(styles.error, className), style: style }, { children: [jsx(ErrorCarIcon, { className: styles.errorIcon }), jsx("h1", __assign({ className: styles.errorTitle }, { children: title })), jsx("h2", __assign({ className: styles.errorDescription }, { children: description })), children] })));
};

export { Error };
